import { render } from "./ManuAccManage.vue?vue&type=template&id=41a68574&scoped=true"
import script from "./ManuAccManage.vue?vue&type=script&lang=js"
export * from "./ManuAccManage.vue?vue&type=script&lang=js"

import "./ManuAccManage.vue?vue&type=style&index=0&id=41a68574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a68574"]])

export default __exports__